<template>
  <v-navigation-drawer clipped app v-model="localDrawer">
    <!-- User info -->
    <v-list-item class="px-2" to="/profile">
      <v-list-item-avatar>
        <img :src="user.photoUrl" :alt="user.fullName" />
      </v-list-item-avatar>
    </v-list-item>
    <v-list-item to="/profile" active-class="white">
      <v-list-item-content>
        <v-list-item-title>{{ user.fullName }}</v-list-item-title>
        <v-list-item-subtitle>{{ user.mail }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense nav>
      <span v-for="item in items[user.type]" :key="item.title">
        <v-list-item style="display: flex" :to="item.to" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </span>
    </v-list>
    <!-- Bottom items -->
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["drawer"],
  data() {
    return {
      items: {
        coach: [
          {
            title: "Vue d'ensemble",
            icon: "mdi-view-dashboard",
            to: "/dashboard/index",
          },
          {
            title: "Calendrier",
            icon: "mdi-calendar-clock",
            to: "/dashboard/calendar",
          },
          // {
          //   title: "Live training",
          //   icon: "mdi-video-wireless-outline",
          //   to: "/dashboard/live",
          // },
          {
            title: "Statistiques",
            icon: "mdi-chart-bar",
            to: "/dashboard/insights",
          },
          {
            title: "Notifications",
            icon: "mdi-bell",
            to: "/dashboard/notifications",
          },
          {
            title: "Demandes",
            icon: "mdi-account-multiple-plus",
            to: "/dashboard/requests",
          },
          {
            title: "Facturations",
            icon: "mdi-shopping-outline",
            to: "/dashboard/billing",
          },
        ],
        user: [
          {
            title: "Vue d'ensemble",
            icon: "mdi-view-dashboard",
            to: "/dashboard/index",
          },
          {
            title: "Calendrier",
            icon: "mdi-calendar-clock",
            to: "/dashboard/calendar",
          },
          // {
          //   title: "Live training",
          //   icon: "mdi-video-wireless-outline",
          //   to: "/dashboard/live",
          // },
          {
            title: "Statistiques",
            icon: "mdi-chart-bar",
            to: "/dashboard/insights",
          },
          {
            title: "Notifications",
            icon: "mdi-bell",
            to: "/dashboard/notifications",
          },
          {
            title: "Facturations",
            icon: "mdi-shopping-outline",
            to: "/dashboard/billing",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
    localDrawer: {
      get() {
        return this.drawer;
      },
      set(value) {
        this.$emit("update:drawer", value);
      },
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  height: calc(100vh - 70px) !important;
  top: 70px !important;
  max-height: calc(100% - 0px);
}
.v-avatar {
  height: 60px !important;
  width: 60px !important;
  margin: 10px auto !important;
}
.v-list .v-list-item--active {
  color: #eb4d4b !important;
}
</style>